import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'title',
  standalone: true,
})
export class TitlePipe implements PipeTransform {
  transform(
    wday: {
      from: string;
      to: string;
    }[],
    day: number,
    fcstTimeForSeason: string,
    forecastForSeasonTranslation: string,
    amTranslation: string,
    untilTranslation: string
  ) {
    return day === 0
      ? forecastForSeasonTranslation
      : wday[day].from +
          ' ' +
          fcstTimeForSeason +
          ' ' +
          amTranslation +
          ' ' +
          untilTranslation +
          ' ' +
          wday[day].to +
          ' ' +
          fcstTimeForSeason +
          ' ' +
          amTranslation;
  }
}
